var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg_(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_218_10986)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.356 36.5327C474.048 31.6696 482.506 23.8482 493.289 29.5552C499.779 32.9903 515.363 42.6223 517.393 51.7565C517.393 54.2938 515.744 59.622 509.147 60.6369",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.258 124.346C371.453 136.398 361.811 163.04 353.692 173.189C318.593 210.825 250.298 309.821 257.91 404.715C257.698 428.607 272.499 476.773 333.394 478.295C341.006 477.872 358.64 476.139 368.281 472.586C384.139 476.604 421.944 478.676 446.302 454.826C452.222 448.482 460.511 435.035 446.302 431.99C447.188 431.163 448.321 429.997 449.494 428.623L452.692 429.711C499.885 442.397 509.146 424.425 507.878 413.853C510.922 390.51 490.117 392.286 479.333 396.092C476.289 389.495 486.945 362.896 492.654 350.421C517.012 293.586 502.803 241.741 492.654 222.923L492.598 223.023C490.419 217.632 487.009 213.168 481.824 211.248L486.898 194.756C498.739 195.813 526.099 193.741 540.815 176.995C547.793 167.691 560.606 146.04 556.039 133.861C554.347 128.364 547.159 114.578 531.935 103.414C531.723 90.7276 522.557 74.1983 514.808 60.9147C508.888 50.7657 492.654 33.6021 469.138 31.7361C438.786 29.3279 384.773 41.2509 375.258 124.346Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.646 148.809C551.646 155.816 545.52 162.13 532.804 162.13C520.089 162.13 509.781 156.45 509.781 149.444C509.781 142.437 520.089 136.757 532.804 136.757C545.52 136.757 551.646 141.803 551.646 148.809Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.958 300.216C346.964 300.399 346.919 300.595 346.902 300.784C346.947 300.936 346.998 301.132 347.053 301.362C347.556 303.468 348.399 308.46 348.542 309.923C348.973 314.345 348.701 318.492 347.3 322.777C345.106 329.489 340.87 335.688 335.881 340.637C333.1 343.395 330.321 344.172 326.538 344.749C322.882 345.308 319.476 343.588 316.493 341.513C314.192 339.912 311.654 338.488 309.781 336.35C308.336 334.701 307.487 332.877 306.467 330.972C304.368 327.052 303.978 323.043 303.672 318.715C303.34 314.019 304.635 308.706 305.803 304.153C306.435 301.687 307.782 299.376 308.881 297.093C309.815 295.151 310.828 293.148 312.362 291.605C314.819 289.135 317.378 286.035 320.758 284.851C323.842 283.77 328.083 284.231 331.268 284.847C336.106 285.784 340.609 290.482 343.827 293.9C344.725 294.855 345.763 295.895 346.207 297.164L346.226 297.219C346.557 298.161 346.926 299.215 346.958 300.216Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.188 309.301C350.343 305.743 358.225 300.12 364.517 306.086",
    stroke: "#1C1B1F",
    strokeWidth: 7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.379 290.238C341.442 286.566 347.8 280.293 354.836 280.3",
    stroke: "#1C1B1F",
    strokeWidth: 7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.999 287.035C322.454 285.136 321.964 275.519 325.1 271.625",
    stroke: "#1C1B1F",
    strokeWidth: 7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.969 301.429C307.68 300.908 300.56 298.97 298.395 295.378",
    stroke: "#1C1B1F",
    strokeWidth: 7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.912 319.423C303.885 320.506 294.695 322.134 290.16 319.977",
    stroke: "#1C1B1F",
    strokeWidth: 7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.268 325.006C345.319 327.966 349.196 334.979 348.29 339.344",
    stroke: "#1C1B1F",
    strokeWidth: 7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.219 336.473C328.929 340.232 329.706 348.728 327.143 352.641",
    stroke: "#1C1B1F",
    strokeWidth: 7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.27 331.657C313.137 334.271 307.812 339.526 303.577 339.634",
    stroke: "#1C1B1F",
    strokeWidth: 7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.865 125.339C367.059 137.391 357.418 164.032 349.299 174.181C314.2 211.817 245.905 310.813 253.517 405.707C253.305 429.6 268.106 477.765 329.001 479.288C336.612 478.865 354.246 477.131 363.888 473.579C379.746 477.596 417.551 479.668 441.909 455.818C447.829 449.475 456.118 436.027 441.909 432.983C445.081 430.022 451.424 422.707 451.424 417.125C456.287 396.404 455.23 360.036 412.096 380.334",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.947 47.953C419.708 49.9265 424.571 53.4504 425.417 55.5648C429.476 67.2363 418.439 86.4349 411.462 94.8924C388.119 123.31 367.905 121.957 360.716 117.728C368.836 107.071 370.02 81.1489 369.597 69.5198C368.074 49.2217 390.529 46.6844 401.947 47.953Z",
    fill: "#1C1B1F",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.356 187.403C459.67 187.403 447.618 181.694 434.932 167.104",
    stroke: "#1C1B1F",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.081 331.492L469.819 273.769",
    stroke: "#1C1B1F",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.891 497.683C244.129 506.31 268.106 475.059 273.815 458.355L306.165 482.46C264.554 531.175 213.978 512.907 193.891 497.683Z",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.507 451.378C387.146 458.144 362.873 472.437 348.665 475.482",
    stroke: "#1C1B1F",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.81 162.129C527.964 165.3 525.892 171.771 524.37 172.278",
    stroke: "#1C1B1F",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.192 181.915C503.227 176.629 521.833 167.833 531.982 174.938",
    stroke: "#1C1B1F",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 469.819,
    cy: 112.653,
    rx: 6.97749,
    ry: 7.6118,
    transform: "rotate(68.2209 469.819 112.653)",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.97749,
    cy: 7.6118,
    rx: 6.97749,
    ry: 7.6118,
    transform: "matrix(-0.37103 0.928621 0.928621 0.37103 511.153 94.8911)",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.728 330.607C254.417 337.924 218.309 326.282 216.318 295.936C216.59 288.449 220.676 273.989 234.846 276.047C241.603 278.27 247.585 284.174 244.101 300.836C238.805 313.135 218.092 332.272 177.602 310.428",
    stroke: "#1C1B1F",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.409 203.895C500.055 218.907 524.244 266.565 495.826 337.101C491.598 348.096 482.886 371.354 481.871 376.429C480.391 380.869 478.827 389.623 484.409 389.115C493.712 386.578 507.244 385.943 509.781 401.801C510.416 412.585 504.072 432.756 473.625 427.174C467.494 426.54 454.469 420.323 453.961 415.756",
    stroke: "#1C1B1F",
    strokeWidth: 13,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.222 366.654C220.824 360.632 251.91 353.271 275.44 372.007",
    stroke: "#1C1B1F",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.105 282.234C279.271 275.48 265.635 257.714 265.766 240.684",
    stroke: "#1C1B1F",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.613 396.732C184.59 396.732 183.631 407.876 181.404 413.448C180.895 417.308 180.181 425.651 181.404 428.137C190.038 442.726 175.409 452.114 167.015 454.984C148.104 461.063 143.376 447.049 143.376 439.281C141.732 448.197 133.783 449.75 130.015 449.412C113.981 448.602 112.714 434.891 114.084 428.137C116.551 411.523 128.816 414.461 134.64 418.007C130.529 411.523 132.927 406.525 134.64 404.836C145.432 394.199 156.566 404.33 159.821 411.928C157.765 399.366 166.159 396.563 170.613 396.732Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.404 413.448C183.631 407.876 184.59 396.732 170.613 396.732C166.159 396.563 157.765 399.366 159.821 411.928C156.566 404.33 145.432 394.199 134.64 404.836C132.927 406.525 130.529 411.523 134.64 418.007C128.816 414.461 116.551 411.523 114.084 428.137C112.714 434.891 113.981 448.602 130.015 449.412C133.783 449.75 141.732 448.197 143.376 439.282C143.376 447.049 148.104 461.063 167.015 454.984C175.409 452.114 190.038 442.726 181.404 428.137",
    stroke: "#1C1B1F",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 498.887C65.3704 500.472 56.4519 501.634 49.8148 493.604C44.6296 488.85 32.8074 483.672 27 501",
    stroke: "#1C1B1F",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.84 501.979C130.977 499.511 139.386 496.064 147.928 502.022C154.211 505.222 167.083 507.09 168.303 488.966",
    stroke: "#1C1B1F",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 447C51.4211 449.321 60.4184 453.464 69.0395 451.475C73.1447 449.984 82.4842 447.895 87 451.475",
    stroke: "#1C1B1F",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_218_10986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/피부과_탈모.7e230dd16548b21f90c2b83ac0f72db2.svg";
export { ForwardRef as ReactComponent };